module.exports = __webpack_public_path__ + "static/media/thumbnail.0f23eaa0.png";